import { RelationalActionKinds } from "../RelationalActionKinds";
import { OperatorKinds } from "../OperatorKinds";

export class RelationalActionParameter {
  // item-type、typeをどうするかについては別途検討が必要
  constructor(
    public kind: RelationalActionKinds,
    public itemType: string,
    public pageKey: number,
    public objectId: string,
    public key: string,
    public subKey: string,
    public value: string,
    public operator: OperatorKinds,
    public name: string, // UserDefineLinkValueとUserDefineSearchで使用している
    public valueObjectPageKey: number,
    public valueObjectName: string,
    public valueObjectId: string,
    public copies: number,
    public row: number,
    public column: number,
    ) {
  }
}
